import React from "react";
import {
  MotifActionIcVisibilityOff24px,
  MotifActionIcVisibility24px,
} from "@ey-xd/motif-icon";
import { MotifIcon } from "@ey-xd/motif-react";

const MaskedLabel = ({ value }: { value: any }) => {
  const [masked, setMasked] = React.useState(true);
  return value ? (
    <div className="display-flex justify-content-between">
      {
        <div
          style={
            masked
              ? {
                  flexBasis: "80%",
                  fontWeight: "bold",
                  fontSize: "1.5rem",
                  letterSpacing: "-0.12rem",
                  lineHeight: "50%",
                }
              : { flexBasis: "80%" }
          }
          className="line-break"
        >
          {masked ? value?.replaceAll(/./g, ".") : value}
        </div>
      }
      <div style={{ cursor: "pointer" }} className="pad-t-5 maskedLabel-icon">
        <MotifIcon
          onClick={() => setMasked(!masked)}
          src={
            masked
              ? MotifActionIcVisibilityOff24px
              : MotifActionIcVisibility24px
          }
        ></MotifIcon>
      </div>
    </div>
  ) : (
    <>-</>
  );
};

export default MaskedLabel;
